'use client';
import { Disclosure } from '@headlessui/react';
import Button from '@ui/Button';
import Chip from '@ui/Chip';
import FadeTransition from '@ui/Transitions/FadeTransition';
import Typography from '@ui/Typography';
import React from 'react';
import { HiOutlinePlusCircle } from 'react-icons/hi';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import useUserCausesStore from './store';

function CausesList(props) {
  const { title, causes, expanded = false } = props;
  const setShowEditor = useUserCausesStore((state) => state.setShowEditor);

  const handleEdit = () => {
    setShowEditor(true, causes);
  };

  return (
    <Disclosure defaultOpen={expanded}>
      {({ open }) => (
        <>
          <Disclosure.Button className="flex w-full justify-between items-center">
            <div className="flex justify-start items-center gap-4">
              {/* <img
                src="/assets/icons/causes.svg"
                alt="causes"
                className="h-10 w-10"
              /> */}
              <Typography variant="h3">{title}</Typography>
            </div>
            <MdOutlineKeyboardArrowDown
              className={`${
                open ? 'rotate-180 transform' : ''
              } h-5 w-5 text-text-secondary`}
            />
          </Disclosure.Button>
          <FadeTransition>
            <Disclosure.Panel className="flex flex-wrap gap-4">
              {causes.length === 0 && (
                <div className="flex justify-start items-center flex-1">
                  <Typography variant="h4" color="textDisabled">
                    No causes added yet
                  </Typography>
                </div>
              )}

              {causes.map((cause) => (
                <Chip key={cause.id} color="secondary" text="small">
                  {cause.cause_title}
                </Chip>
              ))}

              {/* <Button variant="icon" className="!p-0" onClick={handleEdit}>
                <HiOutlinePlusCircle className="w-9 h-9 text-chips-secondary" />
              </Button> */}
            </Disclosure.Panel>
          </FadeTransition>
        </>
      )}
    </Disclosure>
  );
}

export default CausesList;
